/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphBarVerticalStackedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Bar Vertical Stacked',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="2" rx=".5" ry=".5" width="34" y="32" />
    <path
      d="M10 24h6v6h-6zM26 16h6v14h-6zM2 26h6v4H2zM18 20h6v10h-6zM24 11v7h-6v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1ZM32 3v11h-6V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1ZM16 19v3h-6v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1ZM8 21v3H2v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Z"
    />
  </svg>`;
};
